import { SxProps } from '@mui/material'

interface TimeRangeSliderStyles {
  title: SxProps
  wrapper: SxProps
  valueLabel: SxProps
}

export const timeRangeSliderStyles: TimeRangeSliderStyles = {
  title: {
    typography: 'textMdSemibold',
    color: 'text.primary900',
  },
  wrapper: {
    gap: 1.5,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  valueLabel: {
    typography: 'textSm',
    color: 'text.primary900',
  },
}
